<template>
  <div>
    <h4>Fiche Analyse</h4>
      
    <data-table
      :data-source="sortedFiches"
      :headers="headers"
      table-class="table-striped table-hover"
    >
      <template slot="actions">
        <a
          href="javascript:void(0)"
          class="btn btn-outline-primary btn-icon"
          data-toggle="modal"
          data-target="#add-fiche"
        >
          <i class="icofont icofont-plus" />
        </a>
      </template>
    </data-table>
            
    <modal
      title="Ajout d'une fiche"
      id="add-fiche"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="adding"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="add-categorie">Type</label>
          <select
            name="add-categorie"
            id="add-categorie"
            class="form-control"
            v-model="type"
            v-select="{placeholder:'Selectoinnez la categorie'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Ajouter
          </button>
        </div>
      </form>
    </modal>
  
    <modal
      title="Modification d'une fiche"
      id="update-fiche"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="editing"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="update-type">Type</label>
          <select
            name="update-type"
            id="update-type"
            class="form-control"
            v-model="type"
            v-select="{placeholder:'Selectoinnez le type de maladie'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </modal>

    <modal 
      title="Voir la fiche"
      id="view-fiche"
      size="x-large"
    > 
      <apercu-reference-valeur v-if="ficheReferenceValeur" />
      <apercu-resultat-direct v-if="ficheResultatDirect" />
      <apercu-interpretation v-if="ficheInterpretation" />
      <template slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <a
              href="javascript:void(0)"
              class="btn btn-primary"
            > Imprimer</a>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
  
  <script>
  import {mapGetters, mapMutations} from 'vuex'
  import DataTable from '../../../../components/dataTable/local.vue'
  import { COMPONENT_TYPE, TEXT_TYPE } from '../../../../components/dataTable/dataType'
  import Modal from '../../../../components/modal.vue'
  import { ADD_FICHE_ANAYLSE, UPDATE_FICHE_ANAYLSE} from '../../../../graphql/ficheAnalyse'
  import { ANALYSE_RESULTAT_DIRECT, ANALYSE_INTERPRETATION, ANALYSE_REFERENCE_VALEUR } from '../../../../constants/app'
  import ApercuReferenceValeur from '../../../../components/admin/sanitaire/ficheAnalyse/apercu/referecenceValeur.vue'
  import ApercuResultatDirect from '../../../../components/admin/sanitaire/ficheAnalyse/apercu/resultatDirect.vue'
  import ApercuInterpretation from '../../../../components/admin/sanitaire/ficheAnalyse/apercu/interpretation.vue'
  const Categorie = () => import('../../../../components/admin/sanitaire/ficheAnalyse/ficheCategorieAnalyse.vue')
  const Actions = () => import('../../../../components/admin/sanitaire/ficheAnalyse/ficheAction.vue')
  export default {
      components: { DataTable, Modal, ApercuReferenceValeur, ApercuResultatDirect, ApercuInterpretation},
      data(){
          return {
              type: null,
              libelle: null,
              has_error: false,
              error_msg: null
          }
      },
      watch: {
        selectedObject: {
              handler(){
                  if(this.selectedObject !== null) {
                      this.libelle = this.selectedObject.libelle
                      this.type = this.selectedObject.categorieAnalyse
                  }
              },
              deep: true
          }
      },
      methods: {
          ...mapMutations({
              done: 'DONE',
              setSelectedObject: 'SET_SELECTED_OBJECT'
          }),
          initForm(){
              this.setSelectedObject(null)
              this.libelle = null
              this.type = null
              this.has_error = false
              this.error_msg = null
          },
          adding(){
              let data = {
                  libelle: this.libelle,
                  categorieAnalyse: this.type
              }
              this.$apollo.mutate({
                  mutation: ADD_FICHE_ANAYLSE,
                  variables: {
                      "fiche": {
                          ...data
                      }
                  },
                  update: (d) => {
                      console.log(d)
                      console.log(`Fiche ${this.libelle} add successfully`)
                  }
                }).then(() => {
                  this.initForm()
                  this.done()
              }).catch((error) => {
                  console.error(error)
                  this.has_error = true
                  this.error_msg = error
              })
          },
          editing(){
              let data = {
                  libelle: this.libelle,
                  categorieAnalyse: this.type
              }
              this.$apollo.mutate({
                  mutation: UPDATE_FICHE_ANAYLSE,
                  variables: {
                      "fiche": {
                          ...data
                      },
                      "uid": this.selectedObject.uid
                  },
                  update: (d) => {
                      console.log(d)
                      console.log(`Fiche ${this.libelle} on ${this.selectedObject.uid} updated successfully`)
                  }
                }).then(() => {
                  this.initForm()
                  this.done()
              }).catch((error) => {
                  console.error(error)
                  this.has_error = true
                  this.error_msg = error
              })
          }
      },
      computed: {
          ...mapGetters({
              selectedObject: 'selectedObject',
              fiches: 'sanitaire/ficheAnalyses',
              types: 'sanitaire/typeFicheAnalyses',
              sections : 'sanitaire/ficheSections'
          }),
          sortedFiches(){
            return [...this.fiches].sort((a,b) => a.libelle.localeCompare(b.libelle))
          },
          typeFiche(){
            if(this.selectedObject !== null){
              let t = this.types.find(item => item.uid === this.selectedObject.categorieAnalyse)
              if(t) return t.code
            } 
            return null
          },
          ficheReferenceValeur(){
            return this.typeFiche === ANALYSE_REFERENCE_VALEUR
          },
          ficheInterpretation(){
            return this.typeFiche === ANALYSE_INTERPRETATION
          },
          ficheResultatDirect(){
            return this.typeFiche === ANALYSE_RESULTAT_DIRECT
          },
          headers(){
              return [
                  {label: 'ID', name: 'uid', type: TEXT_TYPE},
                  {label: 'Libelle', name: 'libelle', type: TEXT_TYPE, sortable: true},
                  {label: 'Type', name: 'type', type: COMPONENT_TYPE, component: Categorie},
                  {label: 'Actions', name: 'action', type: COMPONENT_TYPE, component: Actions}
              ]
          }
      }
  }
  </script>
  
  <style>
  
  </style>